var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/pending_status.tsx";
import classNames from 'classnames';
import React from 'react';
import StatusReplyMentions from 'soapbox/components/status-reply-mentions';
import StatusContent from 'soapbox/components/status_content';
import { HStack } from 'soapbox/components/ui';
import AccountContainer from 'soapbox/containers/account_container';
import PlaceholderCard from 'soapbox/features/placeholder/components/placeholder_card';
import PlaceholderMediaGallery from 'soapbox/features/placeholder/components/placeholder_media_gallery';
import QuotedStatus from 'soapbox/features/status/containers/quoted_status_container';
import { useAppSelector } from 'soapbox/hooks';
import { buildStatus } from '../util/pending_status_builder';
import PollPreview from './poll_preview';
const shouldHaveCard = pendingStatus => {
  return Boolean(pendingStatus.content.match(/https?:\/\/\S*/));
};
const PendingStatusMedia = ({
  status
}) => {
  if (status.media_attachments && !status.media_attachments.isEmpty()) {
    return /*#__PURE__*/React.createElement(PlaceholderMediaGallery, {
      media: status.media_attachments,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 7
      }
    });
  } else if (!status.quote && shouldHaveCard(status)) {
    return /*#__PURE__*/React.createElement(PlaceholderCard, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 12
      }
    });
  } else {
    return null;
  }
};
const PendingStatus = ({
  idempotencyKey,
  className,
  muted
}) => {
  const status = useAppSelector(state => {
    const pendingStatus = state.pending_statuses.get(idempotencyKey);
    return pendingStatus ? buildStatus(state, pendingStatus, idempotencyKey) : null;
  });
  if (!status) return null;
  if (!status.account) return null;
  const account = status.account;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('opacity-50', className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('status', {
      'status-reply': !!status.in_reply_to_id,
      muted
    }),
    "data-id": status.id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('status__wrapper', `status-${status.visibility}`, {
      'status-reply': !!status.in_reply_to_id
    }),
    tabIndex: muted ? undefined : 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "between",
    alignItems: "start",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(AccountContainer, {
    key: account.id,
    id: account.id,
    timestamp: status.created_at,
    hideActions: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "status__content-wrapper",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(StatusReplyMentions, {
    status: status,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(StatusContent, {
    status: status,
    expanded: true,
    collapsable: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(PendingStatusMedia, {
    status: status,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 13
    }
  }), status.poll && /*#__PURE__*/React.createElement(PollPreview, {
    pollId: status.poll,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 29
    }
  }), status.quote && /*#__PURE__*/React.createElement(QuotedStatus, {
    statusId: status.quote,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 30
    }
  })))));
};
export default PendingStatus;